import { ProgramNode } from './program-node';

export class ProgramStepData {
  public lastStep: boolean;
  public chain: Array<ProgramNode[]>;
}
